import { IsNumericFunction } from './isNumeric.types';

/**
 * The `isNumeric` function returns `true` if the value is a finite number or can be cast to a
 * finite number.
 *
 * To view the type definition, click {@link IsNumericFunction here}.
 */
export const isNumeric: IsNumericFunction = (num) => {
    if (typeof num === 'number') {
        return num - num === 0;
    }
    if (typeof num === 'string' && num.trim() !== '') {
        return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    }

    return false;
};
